import React from 'react';
import '@/features/admin/pages/TeamManagement/components/MemberList/MemberList.css';

/**
 * Skeleton loader for a team member row.
 * Used in TeamManagement MemberList view.
 */
export function MemberRowSkeleton() {
  return (
    <div className="member-row member-row--skeleton">
      <div className="member-row__left">
        <div className="admin-skeleton member-avatar" style={{ borderRadius: '0' }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div className="admin-skeleton" style={{ width: 160, height: 13 }} />
          <div className="admin-skeleton" style={{ width: 100, height: 11 }} />
        </div>
      </div>
      <div className="admin-skeleton" style={{ width: 60, height: 13 }} />
    </div>
  );
}

/**
 * Skeleton loader for organization members in SuperOrg view.
 * Uses consistent layout and admin-skeleton shimmer animations.
 */
export function SuperOrgMemberSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 20px',
        borderBottom: '1px solid var(--admin-card-border)',
        gap: '12px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1 }}>
        <div className="admin-skeleton" style={{ width: '34px', height: '34px', borderRadius: '0', flexShrink: 0 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <div className="admin-skeleton" style={{ width: '160px', height: '14px' }} />
          <div className="admin-skeleton" style={{ width: '100px', height: '11px' }} />
        </div>
      </div>
      <div className="admin-skeleton" style={{ width: '60px', height: '14px' }} />
    </div>
  );
}
